import React, { useEffect, useRef, useState } from "react"
import Body from "../../components/body/BodyPage"
import MainLinks from "../../components/navlinks/MainLinks"
import { useTranslation } from "react-i18next";
import { MDBBreadcrumb, MDBBreadcrumbItem, MDBBtn, MDBCol, MDBIcon, MDBScrollspy, MDBScrollspyLink, MDBSelect, 
    MDBTabs, MDBTabsContent, MDBTabsItem, MDBTabsLink, MDBTabsPane, MDBAlert,MDBSpinner,MDBModal,MDBModalDialog,MDBModalContent,MDBModalHeader,
MDBModalTitle,MDBModalBody,MDBModalFooter} from "mdb-react-ui-kit";
import { useNavigate } from "react-router";

import { useLocation } from "react-router";
import { getDeviceOnlineStatusInfo, getExistingOnly911Locations, getSpecificDectDevice, getSpesificAutoDeviceDetails, saveAutoDectDeviceSettings, sendSyncRequest, sendZTPrequest } from "../../apiclients/streamsapi_bridge";
import { useAdminContext } from "../../components/adminstore/Admin-Context";
import { useForm } from "react-hook-form";
import { customSearchFn } from "../../components/CustomSearchUtil/CustomSearch";
import { Tooltip } from "react-tooltip";
import PopupLoader from "../popups/PopupLoader";
import AddDevices from "../popups/phonesystem/AddDevice";
import SaveChanges from "../../components/topviews/saveCancel";
import EditWarning from "../../components/header/EditWarning";
import YealinkDectButtons from "./YealinkDectButtons";
import UIConstant from "../../apiclients/UIConstant";


function YealinkSettings(props) {
    const [autoDeviceDetails, setAutoDeviceDetails] = useState({});
    const [targetView, setTargetView] = useState("");
    const [showWarning, setShowWarning] = useState(false);
    const { isEdited, setEdited } = useAdminContext();
    const [isEnrolled, setIsEnrolled] = useState(true);
    const [errorMessage, seterrorMessage] = useState(false);
    const [isError, setInternalError] = useState(false);
    const [ztpUpdate, setZtpUpdate] = useState(false);
    const [isloading, setIsloading] = useState(false);
    const [locationsInfo, setLocationsInfo] = useState([]);

    const [showAddDevicePopup, setShowAddDevicePopup] = useState(false);

    const [updatesuccessMessage, setUpdateSuccessMessage] = useState("");

    const [replaceDevice, setReplaceDevice] = useState(false); 

    const toggleShow7 = () => {
        setShowAddDevicePopup(!showAddDevicePopup)};

    const [acdActive, setAcdActive] = useState("generalsettings");

    const passcodeRef = useRef(null);
   
    const warningToggle = () => setShowWarning(!showWarning);
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();
    const [formDefaultValues, setFormDefaultValues] = useState({
        settingsInfo: autoDeviceDetails,
    });
    const {
        register,
        control,
        reset,
        formState: { dirtyFields, isDirty, errors },
        handleSubmit,
        setError,
        clearErrors,
        setValue,
        getValues,
    } = useForm({
        defaultValues: formDefaultValues,
    });

    const closePopup = () => {
        setShowAddDevicePopup(false);
    };


    const handleNavigation = () => {
        if (isEdited) {
            setTargetView("/pslanding#tab2");
            setShowWarning(true);
            return;
        }
        navigate("/pslanding", {
            state: { tab: "tab2" },
        });
    };

    const [basicActive, setBasicActive] = useState('tab1');

    const handleBasicClick = (value) => {
        if (value === basicActive) {
            return;
        }

        setBasicActive(value);
    };

    const containerRef = useRef(null);
    const section1 = useRef(null);
    const section2 = useRef(null);


    useEffect(() => {
        const timeoutId = setTimeout(() => {
            const scrollspyLinks = document.querySelectorAll('.nav-link');
            const lastLink = scrollspyLinks[scrollspyLinks.length - 1];
            const stickyParent = lastLink.closest('.sticky-top');
            if (stickyParent && lastLink.classList.contains('active')) {
                lastLink.classList.remove('active');
                for (let i = 0; i < scrollspyLinks.length; i++) {
                    const firstLink = scrollspyLinks[i];
                    const parent = firstLink.closest('.sticky-top');
                    if (parent) {
                        firstLink.classList.add('active');
                        break;
                    }
                }
            }
        }, 100);
        return () => clearTimeout(timeoutId);
    }, []);

    const combineData = location?.state ? JSON.parse(location?.state?.device) : {};
    const [preDeviceInfo, setPreDeviceInfo] = useState(combineData?.preDeviceInfo || "");
    const [nextDeviceInfo, setNextDeviceInfo] = useState(combineData?.nextDeviceInfo || "");
    const [deviceInfo, setDeviceInfo] = useState(combineData?.selMember || "");
    const [deviceListInfo, setDeviceListInfo] = useState(combineData?.deviceList || "");
    const [macAddress, setMacAdress] = useState(
        location.state
            ? location.state.macAdress
                ? location.state.macAdress
                : ""
            : ""
    );
    const [onlineStatusInfo, setOnlineStatusInfo] = useState({
        macAddress: "",
        online_status: false,
        IpAddress: "",
    });



    const fetchAutoDeviceData = async (mac) => {
        console.log("in [fetchAutoDeviceData]" + mac);
        let siteid = JSON.parse(sessionStorage.getItem("admin_session")).siteid;
        let paramjo1 = {};
        paramjo1.siteid = siteid;
        paramjo1.macAdress = mac ? mac : macAddress;
        console.log(
            "sending parameters for api request :" + JSON.stringify(paramjo1)
        );
        let saverepData = await getSpecificDectDevice(siteid, paramjo1);
        if (!saverepData.ok) {
            console.log("Network response was not ok");
        } else {
            let saverepeMsg = await saverepData.json();
            let autoDeviceData = await saverepeMsg.autoDeviceData;
            console.log("response Data :" + JSON.stringify(autoDeviceData));
            console.log("macAddress  ::: " + autoDeviceData.macaddress);
            autoDeviceData.passcode = UIConstant.CISCO_DECT_MODELS.includes(autoDeviceData.devicename) ? autoDeviceData.passcode : autoDeviceData.passcode.substring(0, 4);
            setAutoDeviceDetails(autoDeviceData);
        }
    }

    useEffect(() => {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const mac = urlParams.get('mac_address');
        if (mac) {
            setMacAdress(mac);
        }
        fetchAutoDeviceData(mac);
        getLocationsList();
    }, [])

    const fetchDeviceOnlineStatus = async () => {
        console.log("Making requets to fetch DeviceOnlineStatus ");

        try {
            let macAddress = [];
            macAddress.push(autoDeviceDetails.macaddress);
            var paramsJo = {
                deviceUUID: autoDeviceDetails.device_uuid,
                userid: autoDeviceDetails.agentId,
                macAddresList: macAddress,
            };
            console.log("praramJO:::::::::" + JSON.stringify(paramsJo));

            let api_response = await getDeviceOnlineStatusInfo(
                JSON.parse(sessionStorage.getItem("admin_session")).siteid,
                paramsJo
            );

            if (!api_response.ok) {
                console.log("Network response was not ok for fetchDeviceOnlineStatus ");
            } else {
                console.log("request Succes for  fetchDeviceOnlineStatus  ");

                let apires = await api_response.json();

                console.log("Response recieved for fetchDeviceOnlineStatus:  " + JSON.stringify(apires.deviceStatus));
                const updatedOnlineStatusInfo = apires.deviceStatus.map((device) => ({
                    macAddress: device?.macaddress || "",
                    online_status: device?.online_status || false,
                    IpAddress: device?.IpAddress.replace("sip:", "").split(":")[0] || "",
                }));
                console.log("updatedOnlineStatusInfo ::::::: " + JSON.stringify(updatedOnlineStatusInfo));
                setOnlineStatusInfo(updatedOnlineStatusInfo);
                console.log("online status ::: " + JSON.stringify(onlineStatusInfo)); //liveDeviceInfo = {device_uuid:"e7f9348f-9cf4-486a-9aa3-76516893363c",online_status:true}
            }
        } catch (e) {
            console.log("Error in fetchDeviceOnlineStatus :" + e);
        }
    };


    useEffect(() => {
        if (autoDeviceDetails?.device_uuid) {
            fetchDeviceOnlineStatus();
        }
    }, [autoDeviceDetails])

    const modifytheState = (e, deviceInfo) => {
        e.preventDefault();
        const provisioningMethod = deviceInfo.provisioning_method * 1
        let selMember = provisioningMethod == 3 ? deviceInfo.MacAddress : deviceInfo.deviceUUID;
        const currentIndex = deviceListInfo.findIndex((tmdata) => provisioningMethod == 3 ? tmdata.MacAddress == selMember : tmdata.deviceUUID == selMember);
        const preDeviceInfo = currentIndex > 0 ? deviceListInfo[currentIndex - 1] : null;
        const nextDeviceInfo = currentIndex < deviceListInfo.length - 1 ? deviceListInfo[currentIndex + 1] : null;
        setDeviceInfo(selMember);
        setPreDeviceInfo(preDeviceInfo);
        setNextDeviceInfo(nextDeviceInfo);
        if (provisioningMethod == 3) {
            setMacAdress(selMember);
            fetchAutoDeviceData(selMember)

        } else {
            const combinedData = {
                selMember,
                preDeviceInfo,
                nextDeviceInfo,
                deviceList: deviceListInfo
            }
            navigate("/manualdevicesettings", {
                state: {
                    deviceUUID: selMember, device: JSON.stringify(combinedData)
                },
            });
        }
    };
    const handleEnrollmentToggle = async (e, type, macaddress, devicename) => {
        // Toggle type dynamically
        const jsonObj = { type, macaddress: macaddress, devicename };
        console.log("Sending Request:", JSON.stringify(jsonObj));
        try {
            const siteId = JSON.parse(sessionStorage.getItem("admin_session"))?.siteid;
            const response = await sendZTPrequest(siteId, jsonObj);
            console.log("response :::: " + response);
            let saverepeMsg = await response.json();
            if (!response.ok) {
                console.log("Network response was not ok handleEnroll handleEnrollmentToggle ");
                setInternalError(true);
                seterrorMessage(saverepeMsg.message)
                setZtpUpdate(!ztpUpdate)
                setTimeout(() => {
                    setInternalError(false);
                }, 3000);
                throw new Error("Network response was not ok");
            } else {
                console.log(saverepeMsg)
                if (saverepeMsg.status == "success") {
                    setIsEnrolled(!isEnrolled);
                    localStorage.setItem("s_message", "Enrolled successfully. Please reboot the device.");
                    setZtpUpdate(!ztpUpdate)
                    navigate(0)

                }
            }
        } catch (error) {
            console.log("Network response was not ok [handleEnrollmentToggle] [sendZTPrequest] " + error);
        }
    };

    const handleSyncRequestToggle = async (e, deviceUUID) => {
        e.preventDefault();
        e.stopPropagation();
        e.target.classList.add("rotateSyncIcon")
        if (!deviceUUID) {
            console.error("Device UUID is missing for sync request.");
            return;
        }
        try {
            const jsonObj = {
                devices: [deviceUUID]
            };
            console.log("Sending Sync Request:", JSON.stringify(jsonObj));
            setIsloading(true)
            const response = await sendSyncRequest(jsonObj);
            let responseData = await response.json();
            if (responseData?.status == 200) {
                setIsloading(false)
                setUpdateSuccessMessage("Sync completed successfully!");
                setTimeout(() => {
                    setUpdateSuccessMessage(""); // Clear the success message 
                }, 2000);
            } else {
                console.error("Sync request failed with error:", responseData.error);
                setInternalError(true);
                setTimeout(() => {
                    setIsloading(false)
                    setInternalError(false);
                }, 2000);
                throw new Error("Sync request failed");
            }

        } catch (error) {
            console.log("Network response was not ok [handleSyncRequestToggle] [sendSyncRequest] " + error);
        }

        setTimeout(() => {
            e.target.classList.remove("rotateSyncIcon")
        }, 1000)
    };

    const handleAcdClick = (value) => {
        if (value === acdActive) {
            return;
        }
        if (isEdited) {
            setTargetView(value);
            setShowWarning(true);
            return;
        }

        setAcdActive(value);
    };

    const passcodeInput = (value) => {
        try {
            const consecutive = "0123456789";
            const reverseConsecutive = "9876543210";
            const isCiscoATA = UIConstant.CISCO_DECT_MODELS.includes(autoDeviceDetails?.devicename);

            console.log("request came to passcodeInput  " + value);
            if (value == undefined || value == null || value == '') {
                setValue("settingsInfo.passcode", "", { shouldDirty: true });
                setError("settingsInfo.passcode", { type: "EmptyError", message: "Passcode is required" });
            } else if (value.toString().startsWith(0)) {
                setError("settingsInfo.passcode", { type: "EmptyError", message: "Passcode should not start with zero (0)" });
            } else if (consecutive.includes(value) || reverseConsecutive.includes(value)) {
                setError("settingsInfo.passcode", { type: "EmptyError", message: "Passcode should not contain consecutive numbers." });
            }
            else if ((!isCiscoATA && value.length !== 4) ||  (isCiscoATA && (value.length < 5 || value.length > 6))) {
                setError("settingsInfo.passcode", { type: "EmptyError", message: isCiscoATA ? "Passcode length must be between 5 and 6" : "Passcode length must be 4" });
            } else {
                clearErrors("settingsInfo.passcode");
                setValue("settingsInfo.passcode", value, { shouldDirty: true });
            }
        } catch (e) {
            console.error("[ipPhonesAddDevice.js][passcodeInput] :" + e);
        }
    };

    async function getLocationsList() {
        try {
          let locationsList = await getExistingOnly911Locations(
            JSON.parse(sessionStorage.getItem("admin_session")).siteid
          );
          if (!locationsList.ok) {
            console.log("got an issue whie");
          } else {
            let responseData = await locationsList.json();
            console.log("getExistingOnly911Locations responseData  " + JSON.stringify(responseData)
            );
            if (responseData.status == "success") {
              const finalList = responseData.nineoolocations.map((item) => {
                return {
                  value: item.nineoo_loc_id,
                  text: item.nineoo_loc_name,
                };
              });
              finalList.unshift({ text: "Select 911 Location", value: "" });
              console.log("911finalList :: " + JSON.stringify(finalList));
              setLocationsInfo(finalList);
            }
          }
    
        } catch (error) {
          console.error("Error:", error);
        }
      }

    function onCloseChanges() {
        console.log("reset changes::::::::::::::::::::::::::");
        reset(formDefaultValues);
        passcodeRef.current.value = autoDeviceDetails.passcode
    }

      const onSubmit = async (data) => {
    
        console.log("Saving changes:", data);
    
        console.log("mac onSubmit ")
        try {
          console.dir(data);
          console.log("[ipPhonesAddDevice.js] Dirty Fields :::" + JSON.stringify(dirtyFields));
    
          if (isDirty) {
            console.log("[ipPhonesAddDevice.js] Dirty Fields :::" + JSON.stringify(dirtyFields));
            const inputParams = frameParams(data);
            console.log("request arameters :" + JSON.stringify(inputParams));
            let siteid = JSON.parse(sessionStorage.getItem("admin_session")).siteid;
            inputParams.device_uuid = autoDeviceDetails?.device_uuid
            inputParams.deviceName = autoDeviceDetails?.devicename;
            inputParams.mac_address = macAddress;
            inputParams.phonemacid = autoDeviceDetails.phonemacId;
            inputParams.ipphonetype_id = autoDeviceDetails.ipphonetype_id;
            console.log("params data: " + JSON.stringify(inputParams));
            const ServerRequest = await saveAutoDectDeviceSettings(siteid, inputParams);
            const saverepeMsg = await ServerRequest.json();
    
            if (!ServerRequest.ok || saverepeMsg.status === "failed") {
              console.log("Network response was not ok");
              if (saverepeMsg?.message != "") {
                setError("settingsInfo.sidecarmodeltype", { type: "serverResponse", message: saverepeMsg?.message });
              }
              onCloseChanges()
              setInternalError(true);
              setTimeout(() => {
                setInternalError(false);
              }, 500);
    
            } else {
              localStorage.setItem("s_message", `updated successfully. Please reboot the device.`);
              window.location.reload();
              console.log("Server response is success :");
              fetchAutoDeviceData();
              if (saverepeMsg?.passcodeErrorMessageInfo != "") {
                console.log("serverResponse setting passcode error message");
                setTimeout(() => {
                  setError("settingsInfo.passcode", { type: "serverResponse", message: saverepeMsg?.passcodeErrorMessageInfo });
                }, 300);
              }
            }
          }
        } catch (e) {
          // handle your error
          console.log("error " + e);
        }
      };

      const frameParams = (formdata) => {
    console.log("[IpPhonesAddDevice.js] frame prams: " + JSON.stringify(formdata));

    try {
      var formFields = {};
      console.log("Dirty Fields :::" + JSON.stringify(dirtyFields));

      let settingsinfo_dirtyFields = dirtyFields?.settingsInfo ?? {};

      if (Object.keys(settingsinfo_dirtyFields).length > 0) {
        Object.keys(settingsinfo_dirtyFields).map((key) => {
          if (settingsinfo_dirtyFields[key] && key != "sideCarTypes") {
            formFields[key] = formdata.settingsInfo[key];
          }
        });
      }

      console.log("formFields:   ", JSON.stringify(formFields));

      var jo = {};
      jo.formfields = formFields;
      return jo;
    } catch (e) {
      console.log("Error in [ManualDeviceSettings.js][frameParams] :" + e);
    }
  };

  const handleOk = () => {
    setEdited(false);
    reset();
    if (targetView.indexOf("/") !== -1) {
      const targetValues = targetView.split("#")
      if (targetValues.length > 1) {
        navigate(targetValues[0],
          {
            state: { tab: targetValues[1] },
          }
        );

      } else {
        navigate(targetValues[0]);
      }

    } else {
      setAcdActive(targetView);
    }
    setShowWarning(false);
  };

   useEffect(() => {
      setEdited(isDirty);
  
    }, [isDirty])
 
    const updateSettingsInfoDefault = (newSettingsInfo) => {
        setFormDefaultValues((prevValues) => ({
            ...prevValues,
            settingsInfo: newSettingsInfo,
        }));
    };

    useEffect(() => {
        updateSettingsInfoDefault(autoDeviceDetails);
    }, [autoDeviceDetails])

    useEffect(() => {
        reset(formDefaultValues);
      }, [formDefaultValues, reset]);
    




    return (
        <React.Fragment>
            <>
                <MainLinks active={2} />
                <Body
                    tablinks={2}
                    sublink={10}
                    content={
                        <>
                            <section className="mb-3">
                                <div className="card card-height">
                                    <div className="card-header py-3 ps-0">
                                        <h5 className="mb-0 ">
                                            <MDBBreadcrumb>
                                                <MDBBreadcrumbItem>
                                                    <a
                                                        onClick={(e) => {
                                                            if (isEdited) {
                                                                setTargetView("/phonenumbers");
                                                                setShowWarning(true);
                                                                return;
                                                            }
                                                            navigate("/phonenumbers");
                                                        }} >
                                                        <strong>{t("phoneSystem")}</strong>
                                                    </a>
                                                </MDBBreadcrumbItem>
                                                <MDBBreadcrumbItem active>
                                                    <a onClick={handleNavigation}>
                                                        <strong>{t("IPPhonesDevice")}</strong>
                                                    </a>
                                                </MDBBreadcrumbItem>
                                                <MDBBreadcrumbItem>
                                                    <a href="">
                                                        <strong>
                                                            {" "}
                                                            {autoDeviceDetails.userName}{" "}
                                                            {autoDeviceDetails.designation}
                                                        </strong>
                                                    </a>
                                                </MDBBreadcrumbItem>
                                            </MDBBreadcrumb>
                                            {
                                                Object.keys(combineData).length > 0 && <div className="headerbtns">
                                                    <div className="customtooltip">
                                                        <MDBBtn
                                                            size="sm"
                                                            color="transparent"
                                                            className={preDeviceInfo != null ? "ms-2 " : "ms-2"}
                                                            disabled={preDeviceInfo == null || preDeviceInfo === ""}
                                                            onClick={(e) => modifytheState(e, preDeviceInfo)}
                                                        >
                                                            <i className="fa fa-chevron-left"></i>
                                                        </MDBBtn>
                                                        {preDeviceInfo != null && preDeviceInfo !== "" && (
                                                            <span className="tooltiptext">
                                                                Previous:
                                                                <br />
                                                                {preDeviceInfo != null
                                                                    ? preDeviceInfo.PhoneName
                                                                    : ""}
                                                            </span>
                                                        )}
                                                    </div>
                                                    <div className="customtooltip">
                                                        <MDBBtn
                                                            size="sm"
                                                            color="transparent"
                                                            className={
                                                                nextDeviceInfo != null
                                                                    ? "ms-2 active"
                                                                    : "ms-2 active"
                                                            }
                                                            disabled={
                                                                nextDeviceInfo == null || nextDeviceInfo === ""
                                                            }
                                                            onClick={(e) =>
                                                                modifytheState(e, nextDeviceInfo)
                                                            }
                                                        >
                                                            <i className="fa fa-chevron-right"></i>
                                                        </MDBBtn>
                                                        {nextDeviceInfo != null && nextDeviceInfo !== "" && (
                                                            <span className="tooltiptext">
                                                                Next:
                                                                <br />
                                                                {nextDeviceInfo != null
                                                                    ? nextDeviceInfo.PhoneName
                                                                    : ""}
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>
                                            }
                                        </h5>
                                    </div>
                                    <div className="card-body px-0">
                                        <div className="mt-2 d-flex w-100 justify-content-between ipphone_column mb-3">
                                            <div className="pb-2">
                                                <h5 className="fw-600 mt-2 ">{autoDeviceDetails.userName}</h5>
                                                <p className="mt-1 text-secondary">
                                                    {autoDeviceDetails.designation}
                                                </p>
                                                <p className="mt-1 text-secondary">
                                                    {autoDeviceDetails.devicename}
                                                </p>
                                                <p className="mt-1   text-secondary">
                                                    {autoDeviceDetails.phonename} :{" "}
                                                    {autoDeviceDetails.macaddress}
                                                </p>
                                            </div>


                                            <div className="d-flex align-items-start justify-content-between gap-5">
                                                <div class="d-flex flex-column align-items-center">
                                                    <strong class="">{t("Online")}</strong>
                                                    <span className={
                                                        onlineStatusInfo[0]?.online_status
                                                            ? "green-dot mt-2"
                                                            : "red-dot mt-2"
                                                    }></span>
                                                </div>

                                                <div class="d-flex flex-column align-items-center">
                                                    <strong class="">{t("IPAddress")}</strong>
                                                    <span class="mt-1"> 
                                                        {onlineStatusInfo[0]?.IpAddress}
                                                        </span>
                                                </div>

                                                <div class="d-flex flex-column align-items-center">
                                                    <strong>{t("ZeroTouchStatus")}</strong>
                                                    {autoDeviceDetails.zeroTouchStatus == 1 ? (
                                                        <span className="mt-2 green-dot ZeroTouchRow"></span>
                                                    ) : (
                                                        <a className="text-center color-primary text-decoration-underline"
                                                            onClick={(e) => handleEnrollmentToggle(e, "enroll", autoDeviceDetails.macaddress, autoDeviceDetails.devicename)}
                                                        >
                                                            Enroll
                                                        </a>
                                                    )}
                                                </div>

                                                <div className="d-flex flex-column align-items-center ip_column">
                                                    <strong className="">{t("SyncConfig")}</strong>
                                                    <MDBIcon fas icon="sync-alt" color="primary" className="fs-5 cursor-pointer mt-1"
                                                        onClick={(e) => handleSyncRequestToggle(e, autoDeviceDetails.device_uuid)}
                                                    />
                                                </div>

                                                <div className="d-flex flex-column justify-content-top align-items-center mt-2">

                                                    <div className="position-relative ip_replace_button">
                                                        <MDBBtn
                                                            className="reload-replace-btn reload-replace-icon ip_w100pr"
                                                            onClick={toggleShow7}
                                                        >
                                                            <span className="reload-replace ip_icon"></span>
                                                            <span> {t("replaceDevice")}</span>
                                                        </MDBBtn>
                                                        {/* <MDBBtn>End Hot Desk</MDBBtn> */}
                                                    </div>


                                                </div>

                                            </div>
                                        </div>


                                        <MDBTabs className='my-3'>
                                            <MDBTabsItem>
                                                <MDBTabsLink onClick={() => handleAcdClick("generalsettings")}
                                                    active={acdActive === "generalsettings"}>
                                                    {t("settings")}
                                                </MDBTabsLink>
                                            </MDBTabsItem>
                                            <MDBTabsItem>
                                                <MDBTabsLink onClick={() => handleAcdClick("bulkloginlogout")}
                                                    active={acdActive === "bulkloginlogout"}>
                                                    {t("buttons")}
                                                </MDBTabsLink>
                                            </MDBTabsItem>
                                        </MDBTabs>

                                        <MDBTabsContent>
                                            <MDBTabsPane open={acdActive === 'generalsettings'}>
                                                {/* Tab 1 content */}
                                                <div className="row mt-3">
                                                    <MDBCol
                                                        size="2"
                                                        md="2"
                                                        lg="2"
                                                        sm="12"
                                                        className="col-sm-100 pr-0 leftTabs"
                                                    >
                                                        <MDBScrollspy container={containerRef} offset={500}>
                                                            <MDBScrollspyLink targetRef={section1} >{t("general")}</MDBScrollspyLink>
                                                            <MDBScrollspyLink targetRef={section2} >{t("emergency911")}</MDBScrollspyLink>
                                                        </MDBScrollspy>
                                                    </MDBCol>

                                                    <MDBCol
                                                        size="12"
                                                        md="10"
                                                        sm="12"
                                                        pr-0
                                                        className="col-sm-100 pr-0 leftTabContent"
                                                    >
                                                        <div class="vtabHeight pr-5">
                                                            <div id='element' ref={containerRef} className='scrollspy-example'>
                                                                <section ref={section1} id='section-1'>
                                                                    <div class="card-header py-0 px-0" id="general">
                                                                        <div class="general-settings">{t("general")}</div>
                                                                    </div>

                                                                    <div className="add-numbermain">
                                                                        <div className="tel-numbers">
                                                                            {t("phoneName")}
                                                                        </div>
                                                                        <div className="d-flex w-30">
                                                                            <div className="phoneselect w-100">
                                                                                <input
                                                                                    type="text"
                                                                                    className="form-control"
                                                                                    name={`settingsInfo.phonename`}
                                                                                    onKeyDown={(event) => {
                                                                                        if (!/[a-zA-Z0-9 _]/.test(event.key)) {
                                                                                            event.preventDefault();
                                                                                        }
                                                                                    }}
                                                                                    {...register("settingsInfo.phonename", {
                                                                                        required: {
                                                                                            value: true,
                                                                                            message: "phoneName canot be empty",
                                                                                        },
                                                                                    })}
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                    <div className="add-numbermain">
                                                                        <div>
                                                                            <div>
                                                                                {t("userLocation")}
                                                                            </div>
                                                                            <span className="phrecording">
                                                                                Location Of The Phone's User is Assigned To,
                                                                                User For Filtering The Location
                                                                            </span>
                                                                        </div>
                                                                        <div className="d-flex w-30">
                                                                            <div className="phoneselect w-100">
                                                                                <input
                                                                                    type="text"
                                                                                    className="form-control"
                                                                                    name={`settingsInfo.address`}
                                                                                    {...register("settingsInfo.address", {
                                                                                        required: {
                                                                                            value: false,
                                                                                            message: "Location canot be empty",
                                                                                        },
                                                                                    })}
                                                                                    disabled={true}
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                    <div className="add-numbermain">
                                                                        <div>
                                                                            <div>
                                                                                {t("passcode")}
                                                                            </div>
                                                                            <span className="phrecording">
                                                                                {t("passcodetxt")}
                                                                            </span>
                                                                        </div>
                                                                        <div className="d-flex w-30">
                                                                            <div className="phoneselect w-100">
                                                                                <input
                                                                                    type="text"
                                                                                    className="form-control"
                                                                                    // defaultValue={autoDeviceDetails?.passcode?.substring(0,4)}
                                                                                    defaultValue={
                                                                                        UIConstant.CISCO_DECT_MODELS.includes(autoDeviceDetails?.devicename)
                                                                                          ? autoDeviceDetails?.passcode        // Cisco ATA-191 → full passcode
                                                                                          : autoDeviceDetails?.passcode?.substring(0, 4) // Others → first 4 digits
                                                                                    }
                                                                                    placeholder="Enter a 4-digit passcode"
                                                                                    maxLength={ UIConstant.CISCO_DECT_MODELS.includes(autoDeviceDetails?.devicename) ? 6 : 4} // Restrict length to 6
                                                                                    onKeyDown={(event) => {
                                                                                        if (!/[0-9]/.test(event.key) && event.key !== 'Backspace' && event.key !== 'Delete') {
                                                                                            event.preventDefault();
                                                                                        }
                                                                                    }}
                                                                                    onChange={(e) => {
                                                                                        let value = e.target.value.replace(/[^0-9]/g, '');

                                                                                        if (!UIConstant.CISCO_DECT_MODELS.includes(autoDeviceDetails?.devicename)) {
                                                                                        value = value.substring(0, 4);
                                                                                        } else {
                                                                                        value = value;
                                                                                        }
                                                                                        passcodeInput(value);
                                                                                    }}
                                                                                    ref={passcodeRef}

                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    {errors.settingsInfo?.passcode && (
                                                                        <p className="text-danger text-end pe-3">
                                                                            {errors.settingsInfo.passcode.message}
                                                                        </p>
                                                                    )}

                                                                </section>
                                                                <div className="routing-border p-0"></div>
                                                                <section ref={section2} id='section-2'>

                                                                    <div class="general-settings" id="911settings">
                                                                        {t("emergency911")}
                                                                    </div>
                                                                    <div className="add-numbermain">
                                                                        <div>
                                                                            {t("Select")} {t("an")} {t("emergency911")}{" "}
                                                                            {t("location")}
                                                                        </div>
                                                                        <div className="d-flex w-30">
                                                                            <div className="phoneselect w-100">
                                                                                <MDBSelect
                                                                                    className="w-100"
                                                                                    data={locationsInfo}
                                                                                    search
                                                                                    // searchFn={customSearchFn}
                                                                                    placeholder="Select 911 Location"
                                                                                    value={getValues(
                                                                                        "settingsInfo.profileId"
                                                                                    )}
                                                                                    onChange={(e) => {
                                                                                        if (e && e.value) {
                                                                                            setValue("settingsInfo.profileId", parseInt(e.value), { shouldDirty: true });
                                                                                        }
                                                                                    }
                                                                                    }
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </section>
                                                            </div>


                                                        </div>
                                                    </MDBCol>
                                                </div>
                                            </MDBTabsPane>
                                            {showAddDevicePopup && (
                                                <ShowAddDevicePopup
                                                    replaceDeviceInfo={autoDeviceDetails}
                                                    onClosePopup={closePopup}
                                                    showDevicePopup={setShowAddDevicePopup}
                                                />
                                            )}

                                            {acdActive === "bulkloginlogout" && (
                                                <MDBTabsPane open={acdActive === "bulkloginlogout"}>
                                                    {/* Bulk Login or Logout content */}
                                                    <YealinkDectButtons deviceInfo={autoDeviceDetails} setEdited={setEdited} />
                                                </MDBTabsPane>
                                            )}


                                        </MDBTabsContent>
                                        <MDBModal
                                            open={replaceDevice}
                                            setShow={setReplaceDevice}
                                            tabIndex="-1"
                                        >
                                            <MDBModalDialog>
                                                <MDBModalContent>
                                                    <MDBModalHeader>
                                                        <MDBModalTitle>{t("replaceDevice")}</MDBModalTitle>
                                                        <MDBBtn
                                                            className="btn-close"
                                                            color="none"
                                                            onClick={toggleShow7}
                                                        ></MDBBtn>
                                                    </MDBModalHeader>
                                                    <MDBModalBody>
                                                        {t("replace")} Nick Leyendecker IP Phone 1
                                                    </MDBModalBody>

                                                    <MDBModalFooter>
                                                        <MDBBtn color="secondary" onClick={toggleShow7}>
                                                            {t("close")}
                                                        </MDBBtn>
                                                        <MDBBtn>{t("saveChanges")}</MDBBtn>
                                                    </MDBModalFooter>
                                                </MDBModalContent>
                                            </MDBModalDialog>
                                        </MDBModal>

                                    </div>
                                </div>
                            </section>


                        </>
                    }
                />
                <>
                    {isDirty && (
                        <SaveChanges
                            onClose={onCloseChanges}
                            onSave={(e) => {
                                e.preventDefault();
                                handleSubmit(onSubmit)();
                            }}
                        />
                    )}
                    {
                        isloading && (
                            <div>
                                <div className="loadingclass-popup"></div>
                                <div className="popup-bg-loader loader_align">
                                    <MDBBtn disabled>
                                        <MDBSpinner
                                            size="sm"
                                            role="status"
                                            tag="span"
                                            className="me-2"
                                        />
                                        Loading...
                                    </MDBBtn>
                                </div>
                            </div>
                        )
                    }
                    {updatesuccessMessage && (
                        <MDBAlert
                            open
                            className="alert-center"
                            color="success"
                            autohide
                            position="bottom-right"
                            delay={10000}
                        >
                            <i className="fas fa-check-circle me-3"></i>
                            <span className="alert-msg">{updatesuccessMessage}</span>
                        </MDBAlert>
                    )}
                    {showWarning && (
                        <EditWarning
                            warningToggle={warningToggle}
                            setShowWarning={setShowWarning}
                            onOk={handleOk}
                        />
                    )}
                </>


            </>
        </React.Fragment>
    )
}

function ShowAddDevicePopup(props) {
  console.log("fdkdkshkdshk"  +  props);
  console.log("djggdgdjd" + JSON.stringify(props.replaceDeviceInfo))
  return (
    <>
      <PopupLoader
        title={props.replaceDeviceInfo ? "Replace Device" : "Add Device"}
        content={
          <AddDevices
            replaceDeviceInfo={props.replaceDeviceInfo}
            onClose={(e) => props.onClosePopup()}
          />
        }
        onShow={props.showDevicePopup}
        onClose={props.onClosePopup}
      />
      <Tooltip anchorSelect=".deleteToolTip" place="top" className="exampleTooltip">
        Remove
      </Tooltip>
    </>
  );
}
export default YealinkSettings

